export default {
  "nl": {
    "constants": {
      "address": {
        "city": "Stad",
        "country": "Land",
        "number": "Nummer",
        "street": "Straat",
        "zip": "Postcode"
      },
      "days": [
        "Zon",
        "Ma",
        "Di",
        "Woe",
        "Do",
        "Vr",
        "Za"
      ],
      "languages": {
        "de": "Duits",
        "en": "Engels",
        "fallback_info": "Het lijkt erop dat dit bericht niet beschikbaar is in uw taal. We gebruiken in plaats daarvan een bestaande vertaling in het {fallback_locale}.",
        "fr": "Frans",
        "nl": "Nederlands",
        "pl": "Pools"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Metrisch",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ],
      "profile_statuses": {
        "active": "Actief",
        "added": "Niet uitgenodigd",
        "blocked": "Gedeactiveerd",
        "discarded": "Verwijderd",
        "invited": "Uitgenodigd",
        "invited_at": "Uitgenodigd"
      },
      "profile_statuses_descriptive": {
        "active": "Laatste keer actief op het platform: {session_ended_at}",
        "added": "Nog niet uitgenodigd",
        "blocked": "Gedeactiveerd",
        "discarded": "Verwijderd",
        "invited": "Uitgenodigd maar nog niet aangemeld",
        "invited_at": "Uitgenodigd {invited_at}. Nog niet aangemeld"
      },
      "profile_titles": {
        "dr": "Dokter",
        "mr": "Heer",
        "mrs": "Mevrouw",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Dagen",
        "months": "Maanden",
        "weeks": "Weken"
      },
      "time_units_count": {
        "days": "geen dag | dag | dagen",
        "months": "geen maand | maand | maanden",
        "weeks": "geen week | week | weken"
      },
      "timezones": {
        "Europe/Brussels": "(GMT+01:00) Europa/Brussel",
        "Europe/Lisbon": "(GMT+00:00) Europa/Lissabon",
        "Europe/London": "(GMT+00:00) Europa/Londen",
        "Europe/Madrid": "(GMT+01:00) Europa/Madrid"
      },
      "wind_orientations": {
        "east": "Oostelijk",
        "north": "Noord",
        "northeast": "Noordoost",
        "northwest": "Noordwest",
        "select": "Selecteer Oriëntatie",
        "south": "Zuid",
        "southeast": "Zuidoost",
        "southwest": "Zuidwest",
        "west": "Westelijk"
      }
    }
  }
}